export default __webpack_public_path__ + "static/media/03-mukbang.84cf46ac.mp4";